"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const stimulus_1 = require("@hotwired/stimulus");
require("lightgallery/css/lightgallery.css");
const lightgallery_1 = __importDefault(require("lightgallery"));
class default_1 extends stimulus_1.Controller {
    connect() {
        (0, lightgallery_1.default)(this.element, {
            plugins: [],
            speed: 0,
            selector: this.galleryItemTargets,
        });
    }
}
exports.default = default_1;
default_1.targets = ["galleryItem"];
